<template>
  <div
    class="play-container"
    :class="{ 'play-container--fluid': fluid }"
  >
    <slot />
  </div>
</template>

<script>
/**
 * PlayContainer — responsive page-width wrapper for the Play system.
 *
 * Replaces bootstrap-vue's <b-container>. Centers content with the same
 * breakpoint max-widths as Bootstrap (so swapping in keeps layouts stable);
 * `fluid` makes it full-width. Pair with <PlayRow> / <PlayCol>.
 *
 * VUE3-MIGRATION: nothing Vue 2-specific — already Vue 3-safe.
 */
export default {
  name: 'PlayContainer',
  props: {
    /** Full-width (no max-width clamp) */
    fluid: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.play-container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;

  &--fluid { max-width: none; }
}

/* Bootstrap-parity breakpoints so legacy swaps stay stable */
@media (min-width: 576px)  { .play-container:not(.play-container--fluid) { max-width: 540px; } }
@media (min-width: 768px)  { .play-container:not(.play-container--fluid) { max-width: 720px; } }
@media (min-width: 992px)  { .play-container:not(.play-container--fluid) { max-width: 960px; } }
@media (min-width: 1200px) { .play-container:not(.play-container--fluid) { max-width: 1140px; } }
</style>
